/**
 * Parses "yyyy-MM-dd" as midnight of that day in the local timezone.
 * Use for calendar dates from URL/API when the date represents the user's local day.
 * Do not use new Date(str) or parseISO(str) for date-only strings — they interpret as UTC.
 */
export function parseLocalDateString(dateStr: string): Date {
  const parts = dateStr.split("-").map(Number);
  if (parts.length !== 3) {
    return new Date(NaN);
  }
  const [y, m, d] = parts;
  return new Date(y, m - 1, d);
}

/**
 * Returns timestamp (ms) of local midnight for the given "yyyy-MM-dd" string.
 * Use when reading date from URL or when you need a timestamp for a calendar day.
 */
export function localMidnightTimestamp(dateStr: string): number {
  return parseLocalDateString(dateStr).getTime();
}
